import styled from 'styled-components';
import { StyledBoxProps } from './SectionHeroBoxes.types';
import {
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledContainer = styled.section`
  display: grid;
  max-width: ${container('xlMax')};
  padding: ${spacing('xl4')} ${spacing('md')} ${spacing('md')};
  margin: auto;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: auto auto;
  gap: 1.5rem;

  @media (max-width: ${screen('md')}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 1rem;
  }
`;

const BaseBox = styled.div<StyledBoxProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 2rem;
  min-height: 100px;
  background-color: ${(props) => props.$backgroundColor};
  border-radius: 20px;
  line-height: 36px;

  color: ${(props) => (props.$color ? props.$color : 'var(--headingColor)')};
  line-height: 1.5em;

  @media (min-width: 0) {
    font-size: ${fontSize('md')};
  }

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('md')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
  }
`;

export const StyledBoxOne = styled(BaseBox)`
  &::before {
    content: '';
    width: 80px;
    height: 8px;
    flex-shrink: 0;
    background-color: var(--headingColor);
    margin-bottom: 1rem;
  }

  justify-content: start;

  color: var(--headingColor);
  font-family: ${fontFamily('display')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  line-height: 120%;
  min-height: 3.5em;

  @media (min-width: 0) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    font-size: 1.8rem;
    font-size: ${fontSize('xl3')};
    padding: ${spacing('xl3')} ${spacing('xl')};
  }

  @media (min-width: ${screen('md')}) {
    grid-column: 1 / 3;
    font-size: ${fontSize('xl6')};
  }

  @media (min-width: ${screen('lg')}) {
    grid-column: 1 / 3;
    font-size: ${fontSize('xl9')};
    padding: 3rem 2rem;
  }
`;

export const StyledBoxTwo = styled(BaseBox)`
  grid-column: 1 / 2;
  grid-row: 2 / 3;
  color: white;

  @media (max-width: ${screen('md')}) {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }
`;

export const StyledBoxThree = styled(BaseBox)`
  grid-column: 2 / 3;
  grid-row: 2 / 3;

  @media (max-width: ${screen('md')}) {
    display: none;
  }
`;
